import {
  InventoryItemDispositionSchema,
  InventoryItemGradeSchema,
  InventoryItemKindSchema,
  InventoryItemLifecycleStatusSchema,
} from "@redotech/redo-ims-db-schema/inventory-item-schema";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const inventoryItemFilterInput = z.object({
  returnsCenterId: z.string().optional(),
  advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  kinds: z.array(InventoryItemKindSchema).optional(),
  productIds: z.array(z.string()).max(500).optional(),
  grades: z.array(InventoryItemGradeSchema).optional(),
  ungradedOnly: z.boolean().optional(),
  dispositions: z.array(InventoryItemDispositionSchema).optional(),
  statuses: z.array(InventoryItemLifecycleStatusSchema).optional(),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
});
